angular
    .module('festzelt-os.modules.tickets', [
        'ui.router',
        'festzelt-os.components',
        'festzelt-os.modules.tickets.main',
        'festzelt-os.modules.tickets.templates'
    ]);

// Routes
require('./routes');

// Sub Modules
require('./templates/module');
require('./main/module');



// WEBPACK FOOTER //
// ./src/app/modules/tickets/module.js